import React from 'react';
import { Icon, Box, Grid, Button } from '@mui/material';
import Status from '@/types/Status.type';
import CustomAutocomplete from '@/components/common/CustomAutocomplete';
import { HistoryLatestPlaces } from '@/types/History.type';

type Props = {
  historyLatestPlaces: Array<HistoryLatestPlaces>;
  quickStatuses: Array<Status & { place?: string }>;
  loading: boolean | undefined;
  quickUpdate: (value: any) => void;
};

export type QuickChangeStatusForm = Status & {
  place: string;
};

const QuickChangeStatus: React.FC<Props> = ({ historyLatestPlaces, quickUpdate, quickStatuses }) => {
  return (
    <form>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <CustomAutocomplete
          name={'historyLatestPlaces'}
          type={'autocomplete'}
          label={'行先'}
          options={historyLatestPlaces}
          getOptionLabel={'displayName'}
          onChange={quickUpdate}
          autocompleteProps={{
            style: { backgroundColor: '#ffffff' },
            size: 'small',
          }}
        />
      </Grid>
      <Grid container item spacing={1} mt={1}>
        {quickStatuses.map((element) => (
          <Grid item key={element.id}>
            <Button
              color="primary"
              variant="contained"
              sx={{
                mx: 0,
                px: 0,
                fontWeight: 'bold',
                width: '110px',
                backgroundColor: element.color,
                '&:hover': {
                  backgroundColor: element.color,
                  opacity: '0.6',
                },
              }}
              onClick={() => {
                quickUpdate({
                  id: element.id,
                  name: element.name,
                  place: null, //element.place,
                  returnTimeFlag: element.returnTimeFlag,
                });
              }}
            >
              <Icon>{element.icon}</Icon>
              <Box ml={1} style={{ fontSize: 'medium' }}>
                {element.displayName}
              </Box>
            </Button>
          </Grid>
        ))}
      </Grid>
    </form>
  );
};
export default QuickChangeStatus;
